import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:27009';

interface RoundHistory {
  id: number;
  matchId: string;
  get5MatchId: number;
  mapNumber: number;
  roundNumber: number;
  roundTime?: number;
  winnerSide?: string;
  winnerTeamId?: number;
  team1Score: number;
  team2Score: number;
  reason?: number;
  createdAt: string;
}

interface MatchEvent {
  id: number;
  matchId: string;
  get5MatchId: number;
  eventType: string;
  eventData?: string;
  createdAt: string;
}

class MatchService {
  private getAuthHeader() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async getRoundHistory(matchId: string, mapNumber?: number): Promise<RoundHistory[]> {
    try {
      const url = mapNumber !== undefined 
        ? `${API_URL}/api/match/${matchId}/round-history?mapNumber=${mapNumber}`
        : `${API_URL}/api/match/${matchId}/round-history`;
        
      const response = await axios.get<RoundHistory[]>(url, {
        headers: this.getAuthHeader()
      });
      
      return response.data;
    } catch (error) {
      console.error('Error fetching round history:', error);
      return [];
    }
  }

  async getMatchEvents(matchId: string, eventType?: string): Promise<MatchEvent[]> {
    try {
      const url = eventType
        ? `${API_URL}/api/match/${matchId}/events?eventType=${eventType}`
        : `${API_URL}/api/match/${matchId}/events`;

      const response = await axios.get<MatchEvent[]>(url, {
        headers: this.getAuthHeader()
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching match events:', error);
      return [];
    }
  }

  async getMapStatus(matchId: string): Promise<any> {
    try {
      const response = await axios.get(`${API_URL}/api/match/${matchId}/map-status`, {
        headers: this.getAuthHeader()
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching map status:', error);
      throw error;
    }
  }
}

export const matchService = new MatchService();